import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Aiosell\OtaEventController::retry
* @see app/Http/Controllers/Admin/Aiosell/OtaEventController.php:21
* @route '/ota-events/{event}/retry'
*/
export const retry = (args: { event: string | { id: string } } | [event: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: retry.url(args, options),
    method: 'post',
})

retry.definition = {
    methods: ["post"],
    url: '/ota-events/{event}/retry',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Aiosell\OtaEventController::retry
* @see app/Http/Controllers/Admin/Aiosell/OtaEventController.php:21
* @route '/ota-events/{event}/retry'
*/
retry.url = (args: { event: string | { id: string } } | [event: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return retry.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Aiosell\OtaEventController::retry
* @see app/Http/Controllers/Admin/Aiosell/OtaEventController.php:21
* @route '/ota-events/{event}/retry'
*/
retry.post = (args: { event: string | { id: string } } | [event: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: retry.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Aiosell\OtaEventController::retry
* @see app/Http/Controllers/Admin/Aiosell/OtaEventController.php:21
* @route '/ota-events/{event}/retry'
*/
const retryForm = (args: { event: string | { id: string } } | [event: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: retry.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Aiosell\OtaEventController::retry
* @see app/Http/Controllers/Admin/Aiosell/OtaEventController.php:21
* @route '/ota-events/{event}/retry'
*/
retryForm.post = (args: { event: string | { id: string } } | [event: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: retry.url(args, options),
    method: 'post',
})

retry.form = retryForm

/**
* @see \App\Http\Controllers\Admin\Aiosell\OtaEventController::review
* @see app/Http/Controllers/Admin/Aiosell/OtaEventController.php:43
* @route '/ota-events/{event}/review'
*/
export const review = (args: { event: string | { id: string } } | [event: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: review.url(args, options),
    method: 'post',
})

review.definition = {
    methods: ["post"],
    url: '/ota-events/{event}/review',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Aiosell\OtaEventController::review
* @see app/Http/Controllers/Admin/Aiosell/OtaEventController.php:43
* @route '/ota-events/{event}/review'
*/
review.url = (args: { event: string | { id: string } } | [event: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { event: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { event: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            event: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        event: typeof args.event === 'object'
        ? args.event.id
        : args.event,
    }

    return review.definition.url
            .replace('{event}', parsedArgs.event.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Aiosell\OtaEventController::review
* @see app/Http/Controllers/Admin/Aiosell/OtaEventController.php:43
* @route '/ota-events/{event}/review'
*/
review.post = (args: { event: string | { id: string } } | [event: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: review.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Aiosell\OtaEventController::review
* @see app/Http/Controllers/Admin/Aiosell/OtaEventController.php:43
* @route '/ota-events/{event}/review'
*/
const reviewForm = (args: { event: string | { id: string } } | [event: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: review.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Aiosell\OtaEventController::review
* @see app/Http/Controllers/Admin/Aiosell/OtaEventController.php:43
* @route '/ota-events/{event}/review'
*/
reviewForm.post = (args: { event: string | { id: string } } | [event: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: review.url(args, options),
    method: 'post',
})

review.form = reviewForm

const otaEvents = {
    retry: Object.assign(retry, retry),
    review: Object.assign(review, review),
}

export default otaEvents